// Session Management Service
import { axiosLabAPI } from 'services/axios';
import { showMessage } from 'services/settings/message';
import { LOGGEDIN_USER_DATA, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';

export async function createSession(reference) {
  let sessionData = null;

  try {
    const clientId = sessionStorage.getItem('clientId');
    const userData = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA) || '{}');

     await new Promise(resolve => setTimeout(resolve, 1000)); // 2000 ms = 2 seconds

    const response = await axiosLabAPI({
      method: API_POST_METHOD,
      url: 'lock/session',
      headers: {
        'x-client-id': clientId,
      },
      data: {
        p_user_id: userData.userID,
        p_user_name: userData.userName,
        p_reference: reference
      }
    });

    if (response.data && response.data.STATUSCODE === 200) {
      sessionData = {
        data: response.data.RECORDS,
      };
    } 
  } catch (e) {
    showMessage(e);
  }

  return sessionData;
}


export async function updateSession(references) {
  let sessionData = null;

  try {
    const clientId = sessionStorage.getItem('clientId');

     await new Promise(resolve => setTimeout(resolve, 1000)); // 2000 ms = 2 seconds

    const response = await axiosLabAPI({
      method: API_PUT_METHOD,
      url: 'lock/session',
      headers: {
        'x-client-id': clientId,
      },
      data: {
        p_reference: references
      }
    });

    if (response.data && response.data.STATUSCODE === 200) {
      sessionData = {
        data: response.data.RECORDS,
      };
    }
  } catch (e) {
    showMessage(e);
  }

  return sessionData;
}

export async function waitForClientId(timeout = 5000) {
  const startTime = Date.now();

  while (Date.now() - startTime < timeout) {
    const clientId = sessionStorage.getItem('clientId');

    if (clientId) {
      return clientId;
    }

    await new Promise(resolve => setTimeout(resolve, 100));
  }
  throw new Error('Timeout waiting for CLIENT_ID');
}
